import { Text, BasicButton, Modal, PrimaryButton } from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  onClose: () => void;
  isOpen: boolean;
  billingProfileId?: string;
}

export function BillingDetailsModal({
  onClose,
  isOpen,
  billingProfileId,
}: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBillingProfileNavigation = () => {
    onClose();
    navigate(`/billing/billing-profiles/${billingProfileId}`);
  };

  return (
    <Modal testID="billing-details-modal" isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Billing details")}</DialogHeader>
        <DialogContent>
          <div className={styles.container}>
            <Text style="global/body-primary">
              <Trans>
                In order to use the Apply link feature, you must first complete
                your billing profile.
              </Trans>
            </Text>
          </div>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose}>{t("Close")}</BasicButton>
          <PrimaryButton onPress={handleBillingProfileNavigation}>
            <Trans>Complete billing profile</Trans>
          </PrimaryButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}

const styles = {
  container: css`
    padding: 16px 0;
  `,
};
